module.exports = __webpack_public_path__ + "static/cineplexenglish-logo-74e30a114dfb8669f3ea9e9dc55b3ed9.png";